export const inputReadOnlyProps = {
    InputProps: {readOnly: true},
    sx: {opacity: '0.5'},
};

export const autocompleteInputReadOnlyProps = {
    readOnly: true,
    sx: {opacity: '0.5'},
};
